import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DocumentService } from '../../../../../services/document/document.service';

@Component({
  selector: 'app-details-chiffre-aff',
  templateUrl: './details-chiffre-aff.component.html',
  styleUrls: ['./details-chiffre-aff.component.scss']
})
export class DetailsChiffreAffComponent implements OnInit, OnChanges {

  @Input() clientId: number | null = null;

  totalFactures: number | null = null;
  loading = false;
  error: string | null = null;

  constructor(private documentService: DocumentService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['clientId']) {
      this.loadTotalFactures();
    }
  }

  loadTotalFactures(): void {
    const id = this.clientId != null ? Number(this.clientId) : null;
    if (id == null || isNaN(id)) {
      this.totalFactures = null;
      return;
    }
    this.loading = true;
    this.error = null;
    this.documentService.getStatsClient(id).subscribe({
      next: (res) => {
        this.loading = false;
        if (res?.success && res?.data?.total_factures?.montant_total != null) {
          this.totalFactures = Number(res.data.total_factures.montant_total);
        } else {
          this.totalFactures = 0;
        }
      },
      error: (err) => {
        this.loading = false;
        this.totalFactures = null;
        this.error = err?.error?.message || 'Erreur lors du chargement.';
      }
    });
  }

  formatMontant(montant: number | null | undefined): string {
    if (montant == null || (typeof montant === 'number' && isNaN(montant))) {
      return '--';
    }
    return `${Number(montant).toFixed(3)} TND`;
  }
}
